"use client"

import { useContext } from "react"
import { Navigate } from "react-router-dom"
import { AuthContext } from "../../../contexts/AuthContext"

const UserProfileRedirect = () => {
  const { user } = useContext(AuthContext)

  // Use fallback if _id is missing
  const userId = user?._id || user?.id

  if (user && userId) {
    return <Navigate to={`/userprofile/${userId}`} replace />
  }

  // If no user, redirect to signin
  return <Navigate to="/user-accounts" replace />
}

export default UserProfileRedirect
